import { render } from "./RegistrationStart.vue?vue&type=template&id=77d14f50"
import script from "./RegistrationStart.vue?vue&type=script&lang=js"
export * from "./RegistrationStart.vue?vue&type=script&lang=js"
script.render = render

export default script